import React from 'react'

// Defaults defensivos: si por algún motivo no hay Provider, al menos no crashea
const AuthContext = React.createContext({
    isSignedIn: false,
    user: {},
    loading: true,
    setIsSignedIn: () => {},
    authIsSuccess: () => {},
})

export default AuthContext
